import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from './material/material.module';
import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { AutocompleteFilterComponent } from './components/autocomplete-filter/autocomplete-filter.component';
import { DialogAssignDriverComponent } from './components/dialog-assign-driver/dialog-assign-driver.component';
import { DialogLogoClientComponent } from './components/dialog-logo-client/dialog-logo-client.component';
import { DialogChangeTimespentComponent } from './components/dialog-change-timespent/dialog-change-timespent.component';
import { FormatHoursPipe } from './pipes/format-hours.pipe';
import { ConfirmDialogComponent } from '@components/confirm-dialog/confirm-dialog.component';
import { DialogNotificationComponent } from './components/dialog-notification/dialog-notification.component';
import { ValidateAndCancelComponent } from './components/validate-and-cancel/validate-and-cancel.component';
import { DisplayCommentComponent } from '@components/display-comment/display-comment.component';
import { DisplayedColumnsMenuComponent } from '@components/displayed-columns-menu/displayed-columns-menu.component';
import { MatTableResponsiveDirective } from './directives/mat-table-responsive/mat-table-responsive.directive';
import { RangeDateFilterComponent } from './components/range-date-filter/range-date-filter.component';
import { DialogReportPhotosComponent } from './components/dialog-report-photos/dialog-report-photos.component';
import { DialogChooseDropdownComponent } from './components/dialog-choose-dropdown/dialog-choose-dropdown.component';
import { DialogKooveaManagementComponent } from '@components/dialog-koovea-management/dialog-koovea-management.component';
import { ChipsComponent } from '@components/chips/chips.component';
import { DisplayBooleanComponent } from './components/display-boolean/display-boolean.component';
import { SelectOrdersExportTypeComponent } from './components/select-orders-export-type/select-orders-export-type.component';

@NgModule({
  declarations: [
    FormEditBaseComponent,
    DatatableBaseComponent,
    AutocompleteComponent,
    AutocompleteFilterComponent,
    DialogAssignDriverComponent,
    DialogLogoClientComponent,
    DialogChangeTimespentComponent,
    FormatHoursPipe,
    ConfirmDialogComponent,
    DialogNotificationComponent,
    ValidateAndCancelComponent,
    DisplayCommentComponent,
    DisplayedColumnsMenuComponent,
    MatTableResponsiveDirective,
    RangeDateFilterComponent,
    DialogReportPhotosComponent,
    DialogChooseDropdownComponent,
    DialogKooveaManagementComponent,
    ChipsComponent,
    DisplayBooleanComponent,
    SelectOrdersExportTypeComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  exports: [
    MaterialModule,
    TranslateModule,
    FormEditBaseComponent,
    DatatableBaseComponent,
    AutocompleteComponent,
    AutocompleteFilterComponent,
    DialogAssignDriverComponent,
    FormatHoursPipe,
    ConfirmDialogComponent,
    ValidateAndCancelComponent,
    DisplayCommentComponent,
    DisplayedColumnsMenuComponent,
    MatTableResponsiveDirective,
    RangeDateFilterComponent,
    ChipsComponent,
    DisplayBooleanComponent,
    SelectOrdersExportTypeComponent
  ]
})
export class SharedModule { }
